import "./TheArtist.module.css";
import Navigation from "@/reusable_sections/Header";
import BehindTheLens from "./sections/BehindTheLens";
import FeaturedGear from "./sections/FeaturedGear";
import FooterArchive from "@/reusable_sections/Footer";
export default function TheArtistPage() {
  return <div>
      <Navigation />
      <BehindTheLens />
      <FeaturedGear />
      <FooterArchive />
    </div>;
}